import type { ButtonHTMLAttributes, ReactElement } from 'react';
import { Spinner } from './Spinner.js';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly small?: boolean;
  /** Shows a spinner and blocks further clicks while an action is in flight. */
  readonly loading?: boolean;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: '',
  secondary: 'button--secondary',
  ghost: 'button--ghost',
  danger: 'button--danger',
};

export function Button({
  variant = 'primary',
  small = false,
  loading = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps): ReactElement {
  const classes = ['button', VARIANT_CLASS[variant], small ? 'button--small' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <button {...rest} type={type} className={classes} disabled={disabled === true || loading}>
      {loading ? <Spinner /> : null}
      {children}
    </button>
  );
}
